export const MOBILE_BP = 960
export const TABLET_BP = 800
export const EXTRA_SMALL_BP = 600
